export default __webpack_public_path__ + "3ac5af5.png";